module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "tab"
    }
  }), _c('strong', [_vm._v("TABLES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_11_ch1#tab1"
    }
  }, [_vm._v("1. Negro Population of Chicago, 1850–1930")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_11_ch1#tab2"
    }
  }, [_vm._v("2. State of Birth of Native Non-Whites, Chicago, 1900")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_12_map1#tab3"
    }
  }, [_vm._v("3. Negro Population by Ward, Chicago, 1900 and 1910")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_12_map1#tab4"
    }
  }, [_vm._v("4. Concentration of Negroes in Chicago, 1898–1920")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_12_map1#tab5"
    }
  }, [_vm._v("5. State of Birth of Illinois Negroes, 1900–1910")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#tab6"
    }
  }, [_vm._v("6. Males and Females Over Ten Engaged in Selected Occupations, Chicago, 1900")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#tab7"
    }
  }, [_vm._v("7. Males and Females Over Ten Engaged in Selected Occupations, Chicago, 1910")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_19_ch7#tab8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Nativity of Negroes, Chicago, 1910–20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_19_ch7#tab9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. State of Birth of Illinois Negroes, 1910–20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_19_ch7#tab10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Distribution of Negroes by Census Tracts, Chicago, 1910–20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_19_ch7#tab11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Ten Census Tracts with Highest Negro Percentage, Chicago, 1910–20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780226160702_20_ch8#tab12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Males and Females Over Ten Engaged in Selected Occupations, Chicago, 1920")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3893148e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226160702_08_tab.vue
// module id = 78
// module chunks = 0